import { ICustomerVehicleOrdersHook } from '@models';
import { OrderService } from '@services';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

interface IProps {
  customerId: string | undefined;
  registrationNumber: string | undefined;
}

export const useCustomerVehicleOrders = ({
  customerId,
  registrationNumber,
}: IProps): ICustomerVehicleOrdersHook => {
  const { orderStore } = useStore();
  const { orders, totalCount, currentPage, skipCount, maxResultCount, loading, handlePageChange } =
    orderStore;
  const [service, setService] = useState<string>();
  const [status, setStatus] = useState<string | undefined>();

  useEffect(() => {
    customerId &&
      registrationNumber &&
      orderStore.getAll({
        customerId,
        registrationNumber,
        status,
        service,
        maxResultCount,
        skipCount,
      });
  }, [orderStore, service, customerId, registrationNumber, status, skipCount, maxResultCount]);

  useEffect(() => {
    return () => orderStore.resetOrders();
  }, [orderStore]);

  const handleServiceSearch = debounce((text: string) => {
    setService(text);
    orderStore.setSkipCount(0);
    orderStore.setCurrentPage(1);
  }, 500);

  const handleStatusChange = (text: string) => {
    setStatus(text);
    orderStore.setSkipCount(0);
    orderStore.setCurrentPage(1);
  };

  const fetchAllForExport = useCallback(async () => {
    const result = await OrderService.getAll({
      customerId,
      registrationNumber,
      status,
      service,
      maxResultCount: totalCount || 10000,
      skipCount: 0,
    });
    return result.items;
  }, [customerId, registrationNumber, status, service, totalCount]);

  return {
    loading,
    status,
    dataSource: Array.from(orders.values()),
    totalCount,
    skipCount,
    currentPage,
    maxResultCount,
    handleServiceSearch,
    handleStatusChange,
    handlePageChange,
    fetchAllForExport,
  };
};
